// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { setupAxiosInterceptors } from '@/shared/config/axios-interceptor';

import App from './app.vue';
// import Vue2Filters from 'vue2-filters';
// import { ToastPlugin } from 'bootstrap-vue';
import router from './router';
import * as config from './shared/config/config';
// import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
// import JhiItemCountComponent from './shared/jhi-item-count.vue';
// import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
// import InfiniteLoading from 'vue-infinite-loading';
import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ConfigurationService from '@/admin/configuration/configuration.service';
import LoginService from './account/login.service';
import AccountService from './account/account.service';
import AppealReportService from '@/entities/reports/appeal/appeal-report.service';
// import AlertService from './shared/alert/alert.service';
// import '../content/scss/global.scss';
// import '../content/scss/vendor.scss';
import './shared/quasar/quasar.ts';
import '../content/css/global.css'
import TranslationService from '@/locale/translation.service';
import RegionService from '@/entities/hr/region/region.service';
import HrStructureFinderService from '@/entities/finder-architecture/hr-structure/hr-structure-finder.service';
import BranchFinderService from '@/entities/finder-architecture/branch/branch-finder.service';
import DepartmentFinderService from '@/entities/finder-architecture/department/department-finder.service';
import JobFinderService from '@/entities/finder-architecture/job/job-finder.service';
import PositionService from '@/entities/hr/position/position.service';
import HrStructureService from '@/entities/hr/hr-structure/hr-structure.service';
import BranchService from '@/entities/hr/branch/branch.service';
import DistrictService from '@/entities/hr/district/district.service';
import DepartmentService from '@/entities/hr/department/department.service';
import EmployeeService from '@/entities/hr/employee/employee.service';
import JobService from '@/entities/hr/job/job.service';
import LevelStateService from '@/entities/hr/level-state/level-state.service';
import ChatMessageSeenService from '@/core/chat/chat-message-seen/chat-message-seen.service';
import ChatMemberService from '@/core/chat/chat-member/chat-member.service';
import ChatService from '@/core/chat/chat.service';
import ChatMessageService from '@/core/chat/chat-mesage/chat-message.service';
import DocService from '@/entities/doc/doc/doc.service';
import ContractService from '@/entities/contract/contract.service';
import RefDocDuplicateService from '@/entities/doc/ref-doc-duplicate/ref-doc-duplicate.service';
import RefDocOrganizationService from '@/entities/doc/ref-doc-organization/ref-doc-organization.service';
import RefDocClassificationService from '@/entities/doc/ref-doc-classification/ref-doc-classification.service';
import RefDocTypeService from '@/entities/doc/ref-doc-type/ref-doc-type.service';
import DocFileService from '@/entities/doc/doc-file/doc-file.service';
import RefDocCountryService from '@/entities/doc/ref-doc-country/ref-doc-country.service';
import RefDocAppealerService from '@/entities/doc/ref-doc-appealer/ref-doc-appealer.service';
import DocJournalService from '@/entities/doc/doc-journal/doc-journal.service';
import EmployeeFinderService from '@/entities/finder-architecture/employee/employee-finder.service';
import DocPriorityService from '@/entities/doc/doc-priority/doc-priority.service';
import DocSourceFormService from '@/entities/doc/doc-source-form/doc-source-form.service';
import DocSourceFormCategoryService from '@/entities/doc/doc-source-form-category/doc-source-form-category.service';
import DocReceptionService from '@/entities/doc/doc-reception/doc-reception.service';
import MovementRuleService from '@/entities/settings/movement-rule/movement-rule.service';
import MovementRuleFieldCategoriesService from '@/entities/settings/ref/movement-rule-field-categories/movement-rule-field-categories.service';
import MovementRuleTypeCategoriesService from '@/entities/settings/ref/movement-rule-type-categories/movement-rule-type-categories.service';
import MovementRuleFieldService from '@/entities/settings/ref/movement-rule-field/movement-rule-field.service';
import MovementRuleTypeService from '@/entities/settings/ref/movement-rule-type/movement-rule-type.service';
import DocJuridicalService from '@/entities/doc/doc-juridical/doc-juridical.service';
import FileStorageService from '@/entities/ref/file-storage/file-storage.service';
import TaskPurposeService from '@/entities/resolution/task-purpose/task-purpose.service';
import TaskTypeService from '@/entities/resolution/task-type/task-type.service';
import ResolutionService from '@/entities/resolution/resolution/resolution.service';
import TaskReceivedService from '@/entities/resolution/task-received/task-received.service';
import TaskService from '@/entities/resolution/task/task.service';
import TaskGroupService from '@/entities/resolution/task-group/task-group.service';
import ReceivedAnswerTypeService from '@/entities/resolution/received-answer-type/received-answer-type.service';
import ReceivedAnswerService from '@/entities/resolution/received-answer/received-answer.service';
import ReceivedAnswerFileService from '@/entities/resolution/received-answer-file/received-answer-file.service';
import DashboardService from '@/core/dashboard/dashboard.service';
import DocFileOfficeService from '@/entities/core/doc-files/doc-file-office.service';
import RoleService from '@/entities/role/role.service';
import JobRoleService from '@/entities/role-panel/job-role.service';
import InternalDocTypeService from '@/entities/doc/internal-doc-type/internal-doc-type.service';
import SignService from '@/core/sign/sign.service';
import TemplateFolderService from '@/entities/ref/folder/template-folder.service';
import GeneralReferenceService from '@/entities/ref/general-reference/general-reference.service';
import AppAnnouncementService from '@/entities/app-announcement/app-announcement.service';
import DocOutsideService from '@/entities/doc/doc-outside/doc-outside.service';
import TakeActionService from '@/core/home/employee-kpi-table/punishment/take-action.service';
import TaskContentService from '@/entities/resolution/task-content/task-content.service';
import RefDocClassificationTypeService from '@/entities/doc/ref-doc-classification-type/ref-doc-classification-type.service';
// import DirectionService from '@/entities/kpi/direction/direction.service';
// import GoalService from '@/entities/kpi/goal/goal.service';
// import MeasureService from '@/entities/kpi/measure/measure.service';
// import ActionEventService from '@/entities/kpi/action-event/action-event.service';
// import KpiTaskService from '@/entities/kpi/task/kpi-task.service';
// import TaskAnswerService from '@/entities/kpi/task-answer/task-answer.service';
import UzCryptoService from '@/shared/uz-crypto-sign-service';
import ChatTaskReceivedService from '@/core/chat-task-received/chat-task-received.service';
import RefAreaService from '@/entities/hr/ref-area/ref-area.service';
import VideoTutorialService from "@/entities/video-tutorial/video-tutorial.service";
import EmployeeBirthdayService from "@/entities/employee-birthday/employee-birthday.service";
import EmployeeCalendarService from "@/entities/reports/employee-calendar/employee-calendar.service";
import ReportsService from "@/entities/reports/reports.service";

/* tslint:disable */

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
// config.initFortAwesome(Vue);
// bootstrapVueConfig.initBootstrapVue(Vue);
// Vue.use(Vue2Filters);
// Vue.use(ToastPlugin);
// Vue.component('font-awesome-icon', FontAwesomeIcon);
// Vue.component('jhi-item-count', JhiItemCountComponent);
// Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
// Vue.component('infinite-loading', InfiniteLoading);
const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, (<any>Vue).cookie, router);
const chatMessageService = new ChatMessageService(router, store);

router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    if (to.fullPath && to.fullPath.search('oauth2/authorization/oidc') > -1) {
      next('/');
    } else {
      next('/not-found');
    }
  } else if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/forbidden');
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),

    translationService: () => translationService,
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    // alertService: () => new AlertService(),
    fileStorageService: () => new FileStorageService(),
    regionService: () => new RegionService(),
    hrStructureFinderService: () => new HrStructureFinderService(),
    branchFinderService: () => new BranchFinderService(),
    departmentFinderService: () => new DepartmentFinderService(),
    jobFinderService: () => new JobFinderService(),
    positionService: () => new PositionService(),
    employeeFinderService: () => new EmployeeFinderService(),
    hrStructureService: () => new HrStructureService(),
    branchService: () => new BranchService(),
    districtService: () => new DistrictService(),
    departmentService: () => new DepartmentService(),
    employeeService: () => new EmployeeService(),
    jobService: () => new JobService(),
    levelStateService: () => new LevelStateService(),
    chatService: () => new ChatService(),
    chatMessageService: () => chatMessageService,
    chatMemberService: () => new ChatMemberService(),
    chatMessageSeenService: () => new ChatMessageSeenService(),
    refDocTypeService: () => new RefDocTypeService(),
    refDocOrganizationService: () => new RefDocOrganizationService(),
    refDocClassificationService: () => new RefDocClassificationService(),
    refDocClassificationTypeService: () => new RefDocClassificationTypeService(),
    refDocCountryService: () => new RefDocCountryService(),
    refDocAppealerService: () => new RefDocAppealerService(),
    refDocDuplicateService: () => new RefDocDuplicateService(),
    docFileService: () => new DocFileService(),
    docService: () => new DocService(),
    contractService: () => new ContractService(),
    docJournalService: () => new DocJournalService(),
    docPriorityService: () => new DocPriorityService(),
    docSourceFormService: () => new DocSourceFormService(),
    docSourceFormCategoryService: () => new DocSourceFormCategoryService(),
    docReceptionService: () => new DocReceptionService(),
    movementRuleService: () => new MovementRuleService(),
    movementRuleFieldCategoriesService: () => new MovementRuleFieldCategoriesService(),
    movementRuleTypeCategoriesService: () => new MovementRuleTypeCategoriesService(),
    movementRuleFieldService: () => new MovementRuleFieldService(),
    movementRuleTypeService: () => new MovementRuleTypeService(),
    docJuridicalService: () => new DocJuridicalService(),
    taskPurposeService: () => new TaskPurposeService(),
    taskTypeService: () => new TaskTypeService(),
    resolutionService: () => new ResolutionService(),
    taskReceivedService: () => new TaskReceivedService(),
    taskService: () => new TaskService(),
    taskGroupService: () => new TaskGroupService(),
    receivedAnswerTypeService: () => new ReceivedAnswerTypeService(),
    receivedAnswerService: () => new ReceivedAnswerService(),
    receivedAnswerFileService: () => new ReceivedAnswerFileService(),
    dashboardService: () => new DashboardService(),
    docFileOfficeService: () => new DocFileOfficeService(),
    roleService: () => new RoleService(),
    jobRoleService: () => new JobRoleService(),
    internalDocTypeService: () => new InternalDocTypeService(),
    signService: () => new SignService(),
    templateFolderService: () => new TemplateFolderService(),
    generalReferenceService: () => new GeneralReferenceService(),
    appAnnouncementService: () => new AppAnnouncementService(),
    docOutsideService: () => new DocOutsideService(),
    takeActionService: () => new TakeActionService(),
    taskContentService: () => new TaskContentService(),
    appealReportService: () => new AppealReportService(),
    // directionService: () => new DirectionService(),
    // goalService: () => new GoalService(),
    // measureService: () => new MeasureService(),
    // actionEventService: () => new ActionEventService(),
    // taskAnswerService: () => new TaskAnswerService(),
    uzCryptoService: () => new UzCryptoService(),
    reportsService: () => new ReportsService(),
    chatTaskReceivedService: () => new ChatTaskReceivedService(),
    refAreaService: () => new RefAreaService(),
    videoTutorialService: () => new VideoTutorialService(),
    employeeBirthdayService: () => new EmployeeBirthdayService(),
    employeeCalendarService: () => new EmployeeCalendarService(),
  },
  i18n,
  store,
});

setupAxiosInterceptors(
  error => {
    const url = error.response?.config?.url;
    const status = error.status || error.response.status;
    if (status === 401) {
      // Store logged out state.
      store.commit('logout');
      if (!url.endsWith('api/account') && !url.endsWith('api/authenticate')) {
        // Ask for a new authentication
        window.location.reload();
        return;
      }
    }
    return Promise.reject(error);
  },
  error => {
    return Promise.reject(error);
  }
);
